__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "@amagimedia/stv-host";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@amagimedia/commons", "1.24.5", () => (Promise.all([__webpack_require__.e(5449), __webpack_require__.e(8439), __webpack_require__.e(7718), __webpack_require__.e(8751), __webpack_require__.e(3793), __webpack_require__.e(3752), __webpack_require__.e(6928)]).then(() => (() => (__webpack_require__(86928))))));
			register("@amagimedia/stv-landing", "1.15.12", () => (Promise.all([__webpack_require__.e(6183), __webpack_require__.e(9573), __webpack_require__.e(5449), __webpack_require__.e(8439), __webpack_require__.e(7718), __webpack_require__.e(8751), __webpack_require__.e(3793), __webpack_require__.e(976), __webpack_require__.e(17), __webpack_require__.e(8948)]).then(() => (() => (__webpack_require__(27143))))));
			register("@amagimedia/stv-now", "2.34.23", () => (Promise.all([__webpack_require__.e(5449), __webpack_require__.e(8439), __webpack_require__.e(2694), __webpack_require__.e(7718), __webpack_require__.e(8751), __webpack_require__.e(3793), __webpack_require__.e(3752), __webpack_require__.e(976), __webpack_require__.e(5970), __webpack_require__.e(6567)]).then(() => (() => (__webpack_require__(35970))))));
			register("logrocket", "2.2.1", () => (__webpack_require__.e(6247).then(() => (() => (__webpack_require__(86247))))));
			register("react-dom", "17.0.2", () => (Promise.all([__webpack_require__.e(883), __webpack_require__.e(7718)]).then(() => (() => (__webpack_require__(30883))))));
			register("react-query", "3.39.3", () => (Promise.all([__webpack_require__.e(2405), __webpack_require__.e(7718), __webpack_require__.e(8751), __webpack_require__.e(7234)]).then(() => (() => (__webpack_require__(22405))))));
			register("react-router-dom", "5.3.4", () => (Promise.all([__webpack_require__.e(5449), __webpack_require__.e(5705), __webpack_require__.e(7718)]).then(() => (() => (__webpack_require__(25705))))));
			register("react", "17.0.2", () => (__webpack_require__.e(2451).then(() => (() => (__webpack_require__(92451))))));
			initExternal(10176);
			initExternal(31377);
			initExternal(75676);
			initExternal(82722);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};